import { ENDPOINTS } from 'configs/endpoints';
import { PlaceTypeEntity, PlaceTypeEntityApi, placeTypeSchema } from 'entities/PlaceType';
import { apiStore } from 'stores/global/ApiStore';
import { HandbookStore, HandbookStoreOptions } from 'stores/local/shared/HandbookStore';

export class PlaceTypeHandbookStore extends HandbookStore<PlaceTypeEntity, PlaceTypeEntityApi> {
  private readonly _request = apiStore.createRequest({
    url: ENDPOINTS.placeType.list,
  });

  constructor({ notificationStore }: Omit<HandbookStoreOptions<PlaceTypeEntityApi>, 'entitySchema' | 'loadItems'>) {
    super({
      loadItems: () => this._request.call(),

      entitySchema: placeTypeSchema,
      notificationStore,
    });
  }
}
